import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { MdlFiltrosScreen } from "./MdlFiltrosScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
export const ProyeccionRecuperacionCarteraMain = () => {
  const history = useHistory();
  const location = useLocation();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [recargar, setRecargar] = useState(false);
  const [
    {
      encabezado,
      titulos,
      detalle,
      sucursales,
      titulo,
      lineacredito,
      mostrarcartera,
      totales,
      primerafechainicio,
      primerafechafin,
    },
    setState,
  ] = useState({
    encabezado: "",
    titulos: [],
    detalle: [],
    sucursales: [],
    totales: [],
    titulo: "PROYECCION DE RECUPERACION DE CARTERA",
    lineacredito: "",
    mostrarcartera: "",
    primerafechainicio: "",
    primerafechafin: "",
  });
  useEffect(() => {
    if (location.state === undefined || location.state === null) return;
    const {
      primerafechainicio,
      primerafechafin,
      lineacredito,
      mostrarcartera,
    } = location.state;
    if (
      primerafechainicio === undefined ||
      primerafechainicio === null ||
      primerafechafin === undefined ||
      primerafechafin === null ||
      lineacredito === undefined ||
      lineacredito === null ||
      mostrarcartera === undefined ||
      mostrarcartera === null
    )
      return;
    else {
      setRecargar(true);
      setLoader({ ...loader, mostrar: true });
      const post = {
        inicio: primerafechainicio,
        fin: primerafechafin,
        lineacredito,
        cartera: mostrarcartera,
      };
      request
        .post("RecuperacionCartera/Obtener", post)
        .then((result) => {
          const settitulo = `PROYECCION DE RECUPERACION DE CARTERA ${
            lineacredito === "RV"
              ? " REVOLVENTE "
              : lineacredito === "OP"
              ? " DE OPERACION "
              : mostrarcartera === "VN"
              ? " VENCIDA CONSOLIDA"
              : " POR VENCER CONSOLIDADA"
          }
              ${
                lineacredito === "CO"
                  ? ""
                  : mostrarcartera === "VN"
                  ? " VENCIDA"
                  : " POR VENCER"
              }`;
          setState({
            encabezado: result.encabezado,
            titulos: result.titulos,
            detalle: result.detalle,
            sucursales: result.sucursales,
            titulo: settitulo,
            lineacredito,
            mostrarcartera,
            totales: result.totales,
            primerafechafin,
            primerafechainicio,
          });
          setLoader({ ...loader, mostrar: false });
          setRecargar(false);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          setRecargar(false);
          return;
        });
    }
  }, []);
  const onCargarRecuperacion = ({
    fechainicio,
    fechafinal,
    lineacredito,
    mostrarcartera,
  }) => {
    return new Promise((resolve, req) => {
      setLoader({ ...loader, mostrar: true });
      const post = {
        inicio: fechainicio,
        fin: fechafinal,
        lineacredito,
        cartera: mostrarcartera,
      };
      request
        .post("RecuperacionCartera/Obtener", post)
        .then((result) => {
          const settitulo = `PROYECCION DE RECUPERACION DE CARTERA ${
            lineacredito === "RV"
              ? " REVOLVENTE "
              : lineacredito === "OP"
              ? " DE OPERACION "
              : mostrarcartera === "VN"
              ? " VENCIDA CONSOLIDA"
              : " POR VENCER CONSOLIDADA"
          }
          ${
            lineacredito === "CO"
              ? ""
              : mostrarcartera === "VN"
              ? " VENCIDA"
              : " POR VENCER"
          }`;
          setState({
            encabezado: result.encabezado,
            titulos: result.titulos,
            detalle: result.detalle,
            sucursales: result.sucursales,
            titulo: settitulo,
            lineacredito,
            mostrarcartera,
            totales: result.totales,
            primerafechainicio: fechainicio,
            primerafechafin: fechafinal,
          });
          resolve("Consulta realizada con exito");
          setLoader({ ...loader, mostrar: false });
          return;
        })
        .catch((error) => {
          req(error);
          setLoader({ ...loader, mostrar: false });
          return;
        });
    });
  };
  const onOpenDetalle = (fechainicio, fechafinal, idsucursal, sucursal) => {
    history.push("/Creditoycobranza/ProyeccionRecuperacionCarteraDetalle", {
      fechafinal,
      fechainicio,
      idsucursal,
      sucursal,
      lineacredito,
      mostrarcartera,
      primerafechainicio,
      primerafechafin,
    });
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 

  return (
    <div className="recuperacion-cartera">
      <LoaderScreen loader={loader} />
      <div className="recuperacion-cartera-header">
        <div className="recuperacion-cartera-header-filtrado">
          <MdlFiltrosScreen
            onCargarRecuperacion={onCargarRecuperacion}
            recarga={recargar}
          />
        </div>
        <div className="recuperacion-cartera-header-titulo">{titulo}</div>
      </div>
      <div className="recuperacion-cartera-container scroll">
        <table cellSpacing={0} cellPadding={0}>
          <thead>
            <tr className="tr-1">
              <th rowSpan={2}>Sucursales</th>
              {titulos.map((item) => (
                <th colSpan={3}>{capitalizeWords(item.titulo)}</th>
              ))}
            </tr>
            <tr className="tr-2">
              {titulos.map(() => (
                <>
                  <th>
                    <div>Proyectado</div>
                  </th>
                  <th>
                    <div>Recuperado</div>
                  </th>
                  <th>
                    <div>%</div>
                  </th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {sucursales.map((suc) => (
              <tr>
                <td>{capitalizeWords(suc.sucursal)}</td>
                {titulos.map((title, indextitulo) =>
                  detalle.filter(
                    (det) =>
                      det.idsucursal === suc.idsucursal &&
                      det.idtitulo === title.id
                  ).length > 0 ? (
                    detalle
                      .filter(
                        (det) =>
                          det.idsucursal === suc.idsucursal &&
                          det.idtitulo === title.id
                      )
                      .map((det) => (
                        <>
                          <td
                            onClick={() =>
                              onOpenDetalle(
                                title.inicio,
                                title.fin,
                                suc.idsucursal,
                                suc.sucursal
                              )
                            }
                          >
                            {mostrarcartera === "VN" && indextitulo !== 0
                              ? ""
                              : FormatMoney(det.saldo)}
                          </td>
                          <td>{FormatMoney(det.recuperado)}</td>
                          <td>{FormatMoney(det.porrecuperado)}</td>
                        </>
                      ))
                  ) : (
                    <>
                      <td>0.00</td>
                      <td>0.00</td>
                      <td>0.00</td>
                    </>
                  )
                )}
              </tr>
            ))}
            <tr>
              <td>Total</td>
              {titulos.map((title, indextitulo) =>
                totales.filter((det) => det.idtitulo === title.id).length >
                0 ? (
                  totales
                    .filter((det) => det.idtitulo === title.id)
                    .map((det) => (
                      <>
                        <td>
                          {FormatMoney(
                            mostrarcartera === "VN" && indextitulo !== 0
                              ? 0
                              : det.saldo
                          )}
                        </td>
                        <td>{FormatMoney(det.recuperado)}</td>
                        <td>{FormatMoney(det.porrecuperado)}</td>
                      </>
                    ))
                ) : (
                  <>
                    <td>0.00</td>
                    <td>0.00</td>
                    <td>0.00</td>
                  </>
                )
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
